import { useQuery } from '@tanstack/react-query';
import { api_host } from '../common/globals/constants';
import { getApiKeys } from '../utils/fns/get-api-keys';

export const fetchLastStatusObjectiveByNode = async (user, token, objetivoId) => {
  const url = `${api_host}/reporte/online/indicadores/getLastStatusObjectiveByNode/?user=${user}&token=${token}&objetivoId=${objetivoId}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return response.json();
};

export const useLastStatusObjectiveByNode = (objetivoId, options = {}) => {
  const { user, token } = getApiKeys();

  return useQuery({
    queryKey: ['lastStatusObjectiveByNode', user, objetivoId],
    queryFn: () => fetchLastStatusObjectiveByNode(user, token, objetivoId),
    enabled: !!user && !!token && !!objetivoId,
    refetchInterval: 300000,
    ...options
  });
};
